goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_right_svg$default");
shadow.js.shim.module$src$svg$chevron$chevron_right_svg$default = shadow.js.shim.module$src$svg$chevron$chevron_right_svg.default;
